










import { Component, Vue } from 'vue-property-decorator'
import AmoCRMSettings from '@/components/settings/AmoCRM.vue'

@Component
export default class SettingsView extends Vue {
  tabs: Tab[] = [
    {
      title: 'AmoCRM',
      key: 'amocrm',
      component: AmoCRMSettings
    }
  ]
}

interface Tab {
  title: string
  key: string
  component: typeof Vue
  disabled?: boolean
}
